import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { EvaluationsManager } from '@/components/EvaluationsManager';

interface Evaluation {
  id?: string;
  ao_id: string;
  nom: string;
  description: string;
  ordre: number;
  ponderation_globale_pct: number;
}

interface AOEvaluationsStepProps {
  evaluations: Evaluation[];
  setEvaluations: (evaluations: Evaluation[]) => void;
  aoId: string;
  criteresMap?: Record<number, any[]>;
  onCriteresChange?: (evaluationIndex: number, criteres: any[]) => void;
}

export const AOEvaluationsStep: React.FC<AOEvaluationsStepProps> = ({
  evaluations,
  setEvaluations,
  aoId,
  criteresMap,
  onCriteresChange
}) => {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Évaluations et critères</CardTitle>
          <p className="text-sm text-muted-foreground">
            Définissez les différentes évaluations et leurs critères pour cet appel d'offres.
            Chaque évaluation peut avoir sa propre pondération et ses propres critères détaillés.
          </p>
        </CardHeader>
        <CardContent>
          <EvaluationsManager
            aoId={aoId}
            initialEvaluations={evaluations}
            initialCriteresMap={criteresMap}
            onEvaluationsChange={setEvaluations}
            onCriteresChange={onCriteresChange}
          />
        </CardContent>
      </Card>
    </div>
  );
};